
// universal-mega-menu-section Z-index update when country selector is open

document.addEventListener("DOMContentLoaded", function () {
  var megaMenu = document.querySelector(".universal-mega-menu-section");
  if (!megaMenu) return;

  var allDropdowns = document.querySelectorAll(".desktop-localization-wrapper .country-selector");
  var dropdown = null;

  for (var i = 0; i < allDropdowns.length; i++) {
    if (!allDropdowns[i].closest(".menu-drawer__navigation-container")) {
      dropdown = allDropdowns[i];
      break;
    }
  }

  if (!dropdown) {
    console.warn("❌ No desktop .country-selector found");
    return;
  }

  var observer = new MutationObserver(function () {
    var isVisible = !dropdown.hasAttribute("hidden");

    if (isVisible) {
      megaMenu.style.zIndex = "4";
    } else {
      megaMenu.style.zIndex = "";
    }
  });

  observer.observe(dropdown, {
    attributes: true,
    attributeFilter: ["hidden"],
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".shaddow_btn_custom").forEach((button) => {
    button.addEventListener("click", function () {
      // Remove border
      this.style.setProperty("box-shadow", "-1px 1px 0 black", "important");
      this.style.setProperty("transform", "translateY(1.5px)", "important");

      // Reset border after 1 second
      setTimeout(() => {
        this.style.removeProperty("box-shadow");
        this.style.removeProperty("transform");
      }, 300); // 1000ms = 1 second
    });
  });
});

// Universal mega menu height set 0 when hide on scroll enabled

document.addEventListener("DOMContentLoaded", () => {
  const root = document.documentElement;
  const universalMenu = document.querySelector(".universal-mega-menu-section");

  function isVisible(el) {
    if (!el) return false;
    const style = getComputedStyle(el);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      el.offsetHeight > 0
    );
  }

  function updateUniversalMegaMenuHeight() {
    if (!universalMenu) return;

    const isDesktop = window.innerWidth >= 1070;
    const menuVisible = isVisible(universalMenu);
    const isHiddenByScroll = universalMenu.classList.contains("sticky-hide");

    if (!isDesktop || !menuVisible) {
      // fallback for mobile: reset to 0
      root.style.setProperty("--universal-mega-menu-section", "0px");
      return;
    }

    if (isHiddenByScroll) {
      root.style.setProperty("--universal-mega-menu-section", "0px");
    } else {
      root.style.setProperty(
        "--universal-mega-menu-section",
        `${universalMenu.offsetHeight}px`
      );
    }
  }

  // Initial check
  updateUniversalMegaMenuHeight();

  // Update on scroll and resize
  window.addEventListener("scroll", updateUniversalMegaMenuHeight);
  window.addEventListener("resize", updateUniversalMegaMenuHeight);
});
